window.FBTCalled = false;
window.DealBarCalled = false;
window.EliteProtection_Init = false;
window.cart_have_pre_order = false;

function _btnLoading(el, on) {
  el.classList.toggle('loading', on);
  el.disabled = on;
  el.querySelectorAll('.loading__spinner').forEach(function(s){ s.classList.toggle('hidden', !on); });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if(this.classList.contains("gift-remove")){
        cartItems.updateQuantity_For_Gift(this.dataset.variant,this.dataset.index);
      }else{
        cartItems.updateQuantity(this.dataset.index, 0);
        GA4.remove_from_cart(window.cart.items[this.dataset.index-1],this.getAttribute('unbxdparam_sku'),this.dataset.quantity);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.FBT();
    this.DealBar();
    this.FreeGiftCheck();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  FreeGiftCheck(){
    var _this = this;
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      if(cart.token != cart.attributes['cart_token']){
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:'attributes[cart_token]='+encodeURIComponent(cart.token)});
      }
      // localStorage.setItem("cart_data",JSON.stringify(cart));
      EliteProtection.InitWithCart(cart);
      if(window.EliteProtection_Init == false){
        window.EliteProtection_Init = true;
        this.Checkproduct(cart);
      }
      window.cart = cart;
      var Items = cart.items,
          UnlockedItem = [],
          ExfreeItem = [],
          Arrayupdate = [],
          NeedtoRemove = [],
          NeedtoAdd = [],
          free_items_list = [],
          Rp = { updates: {} },
          onlygift = true,
          Needtoupdate = false,
          Product0 = 42185367355526,
          Product1 = parseInt(document.getElementById('Product1') ? document.getElementById('Product1').value : 0),
          Product2 = parseInt(document.getElementById('Product2') ? document.getElementById('Product2').value : 0),
          Product3 = parseInt(document.getElementById('Product3') ? document.getElementById('Product3').value : 0),
          Product4 = parseInt(document.getElementById('Product4') ? document.getElementById('Product4').value : 0),
          Product5 = 44360428486790,
          total_price = 0,
          $oxygreens_status = false,
          $oxygreens_id,
          $krupt = false,
          $mystery_rtd = 42176760479878,
          $free_rtd_count = 0,
          $c4_50serve = false,
          $dialed_shred = false,
          $burn_of_gods_count = 0,
          $energy_of_gods_count = 0,
          $ehp_total = 0,
          $oxyshred_lean_bar = 0,
          $gymbod_high_protein_count = 0,
          $gymbod_mug_cake_count = 0,
          $total_weight = 0,
          $noway_count = 0,
          $noway_products = [9088420171,7237816909958,6747728019590,7530552426630,7697332666502,7722962354310,7728435691654];

      document.querySelectorAll('.cart-upsell-products .upsell-item').forEach(function(el){ el.style.display = ''; });
      var $200_deal_found = false;
      var $400_deal_found = false;
      var $mystery_stack = 0;
      window.cart_have_pre_order = false;
      free_items_list.push(42994947031174);
      // free_items_list.push(39858743246982);
      for(var i=0; i < Items.length;i++){
          var Item = Items[i];
          if(Item.handle != 'gift-card'){
            if(Item.properties && !Item.properties['_free-product'] && Item.product_type != "HIDE FROM SITE"){
              total_price += Item.final_line_price;
              onlygift = false;
            }
            if(Item.properties && Item.properties['_is_preorder'] == "yes"){
              window.cart_have_pre_order = true;
            }
          }
          if(Item.properties && !Item.properties['_free-product'] && !Item.properties['_free-above_3kg_supps'] && Item.product_type != "HIDE FROM SITE"){
              $total_weight += Item.grams*Item.quantity;
          }

          if($noway_products.includes(Item.product_id)){
            $noway_count += Item.quantity;
          }
          if(Item.product_id == 7576940413062){
            $noway_count += Item.quantity*2;
          }

          if(Item.product_id == 7421989388422){
            if(Item.properties && Item.properties['_custom-bundle-of-handle'] == 'mystery-product-stack'){
              $mystery_stack += Item.quantity;
            }
          }
          if(Item.product_id == 7608696602758){
            $burn_of_gods_count += Item.quantity;
          }
          if(Item.product_id == 7608688672902){
            $energy_of_gods_count += Item.quantity;
          }
          
          if(Item.id == $mystery_rtd){
            $free_rtd_count += Item.quantity;
          }
          if(Item.properties && Item.properties['_free-product']){
            var upsellItem = document.querySelector('.cart-upsell-products .upsell-item[data-handle="'+Item.handle+'"]');
            if(upsellItem) upsellItem.style.display = 'none';
          }
          // if(Item.properties && Item.properties['_200-deal-bar']){
          //   $200_deal_found = true;
          //   Product2 = Item.id;
          // }
          if(Item.properties && Item.properties['_400-deal-bar']){
            $400_deal_found = true;
            Product3 = Item.id;
          }
          if(Item.id == 41752472649862 || Item.id == 41752472682630 || Item.id == 41765049041030 || Item.id == 41765049073798){
            $c4_50serve = true;
          }
          if(Item.vendor == "Mad Science" && Item.product_type != "HIDE FROM SITE"){
            $mad_science = true;
          }
          if(Item.vendor == "EHP Labs" && Item.product_type != "HIDE FROM SITE"){
            $ehp_total += Item.final_line_price;
          }
          if(Item.product_id == 7665235918982){
            $oxyshred_lean_bar += Item.quantity;
          }
          if(Item.product_id == 7215456682118){
            $krupt = true;
          }
          if(Item.product_id == 7078042468486){
            $dialed_shred = true;
          }
          if(Item.product_id == 7546798932102){
            $oxygreens_status = true;
            free_items_list.push(Item.id);
            $oxygreens_id = Item.id;
          }
          if(Item.product_id == 7551434129542){
            $gymbod_high_protein_count += Item.quantity*2;
          }
          if(Item.product_id == 7551422988422){
            $gymbod_mug_cake_count += Item.quantity;
          }
       }
        free_items_list.push(43121436131462);
        free_items_list.push(43121435050118);
        if($dialed_shred == true){
          UnlockedItem.push(43121436131462); // Acetyl L-Carnitine | 30 Serves
          UnlockedItem.push(43121435050118); // Dialed Shaker | 400ml
        }
        
        free_items_list.push(67588849926278); // True Protein Shake | Single
        free_items_list.push(67588849533062); // True Protein Bar | Single
        if($total_weight > 2999){
          UnlockedItem.push(67588849926278); // True Protein Shake | Single
          UnlockedItem.push(67588849533062); // True Protein Bar | Single
        }

        free_items_list.push(44365954809990);
        if($noway_count >= 2){
          UnlockedItem.push(44365954809990); // Collagen Protein | 10 Serves
        }

       if(onlygift == false){
          if(total_price > 39999 && $400_deal_found == false){
            document.querySelectorAll('.gift_product_slider').forEach(function(el){ el.style.display = 'none'; });
            var giftSlider400 = document.querySelector('.gift_product_slider[data-target="400-deal-bar"]');
            if(giftSlider400) giftSlider400.style.display = 'block';
            var giftPopup = document.getElementById('gift_popup');
            if(giftPopup){ giftPopup.classList.remove('rule-1-deal-popup'); giftPopup.style.display = 'block'; }
            UnlockedItem.push(Product5);
            UnlockedItem.push(Product4);
          }else if(total_price > 17999){
            UnlockedItem.push(Product5);
          }
          // else if(total_price > 7999){
          //   UnlockedItem.push(39858743246982); // 100g Free creatine
          // }
          free_items_list.push(40650382901382);
            if(total_price > 39999 && $400_deal_found == true){
              UnlockedItem.push(Product3);
            }

         document.querySelectorAll('.insurance-wrapper-main').forEach(function(el){ el.style.display = ''; });
       }else{
         document.querySelectorAll('.insurance-wrapper-main').forEach(function(el){ el.style.display = 'none'; });
       }
      for(var i=0; i < Items.length;i++){
        var Item = Items[i];
        if(Item.id == Product0 || Item.id == Product1 || Item.id == Product2 || Item.id == Product3 || Item.id == Product4 || Item.id == Product5 || free_items_list.includes(Item.id)){
          if(Item.properties && Item.properties['_free-product']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_spend_150']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_dialed_shred']){
            ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_burn_of_gods']){
            ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_gymbod_high_protein']){
            ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_ehp_labs_spend_$150']){
            ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-above_3kg_supps']){
            ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_noway_x2']){
            ExfreeItem.push(Item.id);
          }
          if(Item.quantity > 1){
            NeedtoRemove.push(Item.id);
            Rp.updates[Item.id] = 1;
          }
         }
       }

      // _free-with_ehp_labs_spend_$150
      if($ehp_total > 14999){
        if($oxyshred_lean_bar == 0){
          $('.bogo-freebie-wrapper').addClass('open-bogo-offer')
          $('.bogo-freebie-drawer').addClass('open-drawer')
          document.body.classList.add('overflow-hidden');
        }else if($oxyshred_lean_bar > 1){
          var $need_to_remove_eog = $oxyshred_lean_bar - ($oxyshred_lean_bar-1);
          for(var i=0; i < Items.length;i++){
            var Item = Items[i];
            if(Item.product_id == 7665235918982){
              if($need_to_remove_eog >= Item.quantity){
                NeedtoRemove.push(Item.id);
                Rp.updates[Item.key] = 0;
                $need_to_remove_eog = $need_to_remove_eog - Item.quantity;
              }else if($need_to_remove_eog < Item.quantity){
                NeedtoRemove.push(Item.id);
                var $removing = Item.quantity - $need_to_remove_eog;
                Rp.updates[Item.key] = $removing;
                $need_to_remove_eog = 0;
              }
            }
          }
        }
      }else if($oxyshred_lean_bar > 0){
        for(var i=0; i < Items.length;i++){
          var Item = Items[i];
          if(Item.product_id == 7665235918982){
              NeedtoRemove.push(Item.id);
              Rp.updates[Item.key] = 0;
          }
        }
      }

      if($gymbod_high_protein_count > 0){
        if($gymbod_high_protein_count > $gymbod_mug_cake_count){
          $('.whey-freebie-wrapper-2').addClass('open-whey-offer')
          $('.whey-freebie-drawer-2').addClass('open-drawer')
          document.body.classList.add('overflow-hidden');
        }else if($gymbod_high_protein_count < $gymbod_mug_cake_count){
          var $need_to_remove_cake = $gymbod_mug_cake_count - $gymbod_high_protein_count;
          for(var i=0; i < Items.length;i++){
            var Item = Items[i];
            if(Item.product_id == 7551422988422){
              if($need_to_remove_cake >= Item.quantity){
                NeedtoRemove.push(Item.id);
                Rp.updates[Item.key] = 0;
                $need_to_remove_cake = $need_to_remove_cake - Item.quantity;
              }else if($need_to_remove_cake < Item.quantity){
                NeedtoRemove.push(Item.id);
                var $removing = Item.quantity - $need_to_remove_cake;
                Rp.updates[Item.key] = $removing;
                $need_to_remove_cake = 0;
              }
            }
          }
        }
       }else if($gymbod_mug_cake_count > 0){
          for(var i=0; i < Items.length;i++){
            var Item = Items[i];
            if(Item.product_id == 7551422988422){
                NeedtoRemove.push(Item.id);
                Rp.updates[Item.key] = 0;
            }
          }
       }

      if($burn_of_gods_count > 0){
        if($burn_of_gods_count > $energy_of_gods_count){
          $('.whey-freebie-wrapper').addClass('open-whey-offer')
          $('.whey-freebie-drawer').addClass('open-drawer')
          document.body.classList.add('overflow-hidden');
        }else if($burn_of_gods_count < $energy_of_gods_count){
          var $need_to_remove_eog = $energy_of_gods_count - $burn_of_gods_count;
          for(var i=0; i < Items.length;i++){
            var Item = Items[i];
            if(Item.product_id == 7608688672902){
              if($need_to_remove_eog >= Item.quantity){
                NeedtoRemove.push(Item.id);
                Rp.updates[Item.key] = 0;
                $need_to_remove_eog = $need_to_remove_eog - Item.quantity;
              }else if($need_to_remove_eog < Item.quantity){
                NeedtoRemove.push(Item.id);
                var $removing = Item.quantity - $need_to_remove_eog;
                Rp.updates[Item.key] = $removing;
                $need_to_remove_eog = 0;
              }
            }
          }
        }
       }else if($energy_of_gods_count > 0){
          for(var i=0; i < Items.length;i++){
            var Item = Items[i];
            if(Item.product_id == 7608688672902){
                NeedtoRemove.push(Item.id);
                Rp.updates[Item.key] = 0;
            }
          }
       }

       var $eligible_rtd = parseInt($mystery_stack/3);
      //  console.log("$eligible_rtd",$eligible_rtd);
       if($eligible_rtd){
        if($free_rtd_count == 0){
          NeedtoAdd.push($mystery_rtd);
        } else{
          if($free_rtd_count != $eligible_rtd){
            NeedtoRemove.push($eligible_rtd);
            Rp.updates[$mystery_rtd] = $eligible_rtd;
          }
        }
       }else{
          if($free_rtd_count > 0){
            NeedtoRemove.push($mystery_rtd);
            Rp.updates[$mystery_rtd] = 0;
          }
       }

      for(var j=0; j < ExfreeItem.length; j++){
         var Ex = ExfreeItem[j];
         if(onlygift){
           Needtoupdate = true;
           NeedtoRemove.push(Ex);
           Rp.updates[Ex] = 0;
         }else{
           if(!UnlockedItem.includes(Ex)){
             Needtoupdate = true;
             NeedtoRemove.push(Ex);
             Rp.updates[Ex] = 0;
           }
         }
       }

      for(var k=0; k < UnlockedItem.length; k++){
         var Fr = UnlockedItem[k];
         if(!ExfreeItem.includes(Fr)){
           Needtoupdate = true;
           if(cart.attributes && cart.attributes[Fr] == "removed"){
           }else{
             NeedtoAdd.push(Fr);
           }
         }
       }

      if(Needtoupdate){ }
       if(NeedtoRemove.length){
          Rp.sections_url = window.location.pathname;
          Rp.sections = _this.getSectionsToRender().map((section) => section.section);
          // return;
          fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(Rp)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            window.cart = parsedState;
            if(NeedtoAdd.length){
             this.ADDTOCART(NeedtoAdd);
            } else{
             _this.CARTUPDATE(parsedState);
            }
          });
       }else if(NeedtoAdd.length){
         this.ADDTOCART(NeedtoAdd);
       }
    });
  }

  ADDTOCART(Products){
    var _this = this;
     if(Products.length){
       let formData = { 'items': [] };
           formData.sections_url = window.location.pathname;
           formData.sections = _this.getSectionsToRender().map((section) => section.section);
      //  console.log("Products",Products);
       for(var i=0; i < Products.length; i++){
        if(Products[i]){
          if(Products[i] == 67588849926278 || Products[i] == 67588849533062){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-above_3kg_supps':'true'} })
          } else if(Products[i] == 44365954809990){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_noway_x2':'true'} })
          } else if(Products[i] == 43121436131462 || Products[i] == 43121435050118){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_dialed_shred':'true'} })
          } else if(Products[i] == 44007102578822 || Products[i] == 44007102611590 || Products[i] == 44007102644358 || Products[i] == 44007102677126){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_burn_of_gods':'true'} })
          } else if(Products[i] == 43348584530054 || Products[i] == 43348584562822){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_gymbod_high_protein':'true'} })
          }else{
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-product':'true'} })
          }
        }
       }
       if(formData.items.length){
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _this.CARTUPDATE(parsedState);
         });
       }
     }
  }

  CARTUPDATE(parsedState){
    localStorage.setItem("cart_data",JSON.stringify(parsedState));
    var _this = this;
    _this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    _this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
        if(elementToReplace){
          elementToReplace.innerHTML = _this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
    });
    if(window.location.search == '?view=cashback' || window.location.pathname == "/account/login"){

    } else{
      CartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      CartDrawer.classList.add('animate', 'active');
    }
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      window.cart = cart;
    });
  }

  FBT(){
    if(window.FBTCalled == false){
        var _this = this;
        window.UpdateCart = function(){
          fetch('/cart.js').then(res => res.json()).then((cart) => {
              if(cart.item_count == 0) return;
              var line = 1;
              var quantity = cart.items[0].quantity;
              const body = JSON.stringify({
                line,
                quantity,
                sections: _this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });

              fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);
                // _this.CARTUPDATE(parsedState);
                // var _this = this;
                _this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                _this.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                    if(elementToReplace){
                      elementToReplace.innerHTML = _this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                      );
                    }
                });
              });
          });
        }

        window.add_NostoFBT_to_cart = function(Items,$this){
          // console.log("add_NostoFBT_to_cart",Items);
          // console.log("$this",$this);
          // $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = Items;
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
                return response.text();
            }).then((state) => {
              const parsedState = JSON.parse(state);
              // console.log("parsedState",parsedState);
              document.querySelectorAll('.nosto-add-bundle').forEach(function(el){
                el.classList.remove('loading');
                el.disabled = false;
                el.querySelectorAll('.loading__spinner').forEach(function(s){ s.classList.add('hidden'); });
              });
              const cartDrawerWrapper = document.querySelector('cart-drawer');
              const cartFooter = document.getElementById('main-cart-footer');
              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.items.length === 0);
              if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.items.length === 0);
              _this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                  if(elementToReplace){
                    elementToReplace.innerHTML = _this.getSectionInnerHTML(
                      parsedState.sections[section.section],
                      section.selector
                    );
                  }
              });
              if(window.location.search == '?view=cashback' || window.location.pathname == "/account/login"){
              } else{
                CartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                CartDrawer.classList.add('animate', 'active');
              }
            });
        }

        window.FBTCalled = true;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        document.addEventListener('click', function(e){
          var el = e.target.closest('.fbt_atc');
          if(!el) return;
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          var d = "_elite_"+Date.now();
          document.querySelectorAll('.fbt_product').forEach(function(prod){
            var selectedOption = prod.querySelector('select option:checked');
            if(selectedOption) formData.items.push({ 'id': selectedOption.value, 'quantity': 1, properties: { '_elite_recommends': d } });
          });
          if(formData.items.length){
            fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
                return response.text();
            }).then((state) => {
              const parsedState = JSON.parse(state);
              _this.CARTUPDATE(parsedState);
              _btnLoading(el, false);
            });
          }
        });

        document.addEventListener('click', function(e){
          var el = e.target.closest('.free-atc-btn');
          if(!el) return;
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': el.dataset.variant, 'quantity': 1, properties: { '_free-product': 'true' } });
          formData.attributes = { [el.dataset.variant]: "added" };
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _this.CARTUPDATE(parsedState);
          });
        });

        document.addEventListener('click', function(e){
          var el = e.target.closest('.gift-whey-atc');
          if(!el) return;
          document.querySelectorAll('.gift-whey-atc').forEach(function(btn){ btn.disabled = true; });
          var $target = '_' + el.closest('.gift_product_slider').dataset.target;
          var $properties = {};
          $properties[$target] = "true";
          $properties["_free-product"] = "true";
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': el.dataset.variant, 'quantity': 1, properties: $properties });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _btnLoading(el, false);
            var giftPopup = document.getElementById('gift_popup');
            if(giftPopup) giftPopup.style.display = 'none';
            document.querySelectorAll('.gift-whey-atc').forEach(function(btn){ btn.disabled = false; });
            _this.CARTUPDATE(parsedState);
          });
        });

        document.addEventListener('click', function(e){
          var el = e.target.closest('.whey-freebie-atc');
          if(!el) return;
          document.querySelectorAll('.whey-freebie-atc').forEach(function(btn){ btn.disabled = true; });
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': el.dataset.variant, 'quantity': 1, properties:{ '_free-with_burn_of_gods': 'true' } });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _btnLoading(el, false);
            document.querySelectorAll('.whey-freebie-wrapper').forEach(function(el){ el.classList.remove('open-whey-offer'); });
            document.querySelectorAll('.whey-freebie-drawer').forEach(function(el){ el.classList.remove('open-drawer'); });
            document.body.classList.remove('overflow-hidden');
            document.querySelectorAll('.whey-freebie-atc').forEach(function(btn){ btn.disabled = false; });
            _this.CARTUPDATE(parsedState);
          });
        });

        document.addEventListener('click', function(e){
          var el = e.target.closest('.whey-freebie-atc-2');
          if(!el) return;
          document.querySelectorAll('.whey-freebie-atc-2').forEach(function(btn){ btn.disabled = true; });
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': el.dataset.variant, 'quantity': 1, properties:{ '_free-with_gymbod_high_protein': 'true' } });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _btnLoading(el, false);
            document.querySelectorAll('.whey-freebie-wrapper-2').forEach(function(el){ el.classList.remove('open-whey-offer'); });
            document.querySelectorAll('.whey-freebie-drawer-2').forEach(function(el){ el.classList.remove('open-drawer'); });
            document.body.classList.remove('overflow-hidden');
            document.querySelectorAll('.whey-freebie-atc-2').forEach(function(btn){ btn.disabled = false; });
            _this.CARTUPDATE(parsedState);
          });
        });

        document.addEventListener('click', function(e){
          var el = e.target.closest('.whey-freebie-atc-3');
          if(!el) return;
          document.querySelectorAll('.whey-freebie-atc-3').forEach(function(btn){ btn.disabled = true; });
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': el.dataset.variant, 'quantity': 1, properties:{ '_free-product': 'true' } });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _btnLoading(el, false);
            document.querySelectorAll('.whey-freebie-wrapper-3').forEach(function(el){ el.classList.remove('open-whey-offer'); });
            document.querySelectorAll('.whey-freebie-drawer-3').forEach(function(el){ el.classList.remove('open-drawer'); });
            document.body.classList.remove('overflow-hidden');
            document.querySelectorAll('.whey-freebie-atc-3').forEach(function(btn){ btn.disabled = false; });
            _this.CARTUPDATE(parsedState);
          });
        });

        document.addEventListener('click', function(e){
          var el = e.target.closest('.bogo-freebie-atc');
          if(!el) return;
          document.querySelectorAll('.bogo-freebie-atc').forEach(function(btn){ btn.disabled = true; });
          _btnLoading(el, true);
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': el.dataset.variant, 'quantity': 1, properties:{ '_free-with_ehp_labs_spend_$150': 'true' } });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _btnLoading(el, false);
            document.querySelectorAll('.bogo-freebie-wrapper').forEach(function(el){ el.classList.remove('open-bogo-offer'); });
            document.querySelectorAll('.bogo-freebie-drawer').forEach(function(el){ el.classList.remove('open-drawer'); });
            document.body.classList.remove('overflow-hidden');
            document.querySelectorAll('.bogo-freebie-atc').forEach(function(btn){ btn.disabled = false; });
            _this.CARTUPDATE(parsedState);
          });
        });
    }
  }

  DealBar(){
    if(window.DealBarCalled == false){
      window.DealBarCalled = true;
      var _this = this;

      document.addEventListener('click', function(e){
        var el = e.target.closest('.upsell-atc');
        if(!el) return;
        _btnLoading(el, true);
        let formData = { 'items': [] };
        formData.sections_url = window.location.pathname;
        formData.sections = _this.getSectionsToRender().map((section) => section.section);
        var selectEl = el.parentElement.querySelector('select');
        var $variant = selectEl ? selectEl.value : null;
        if($variant) formData.items.push({ 'id': $variant, 'quantity': 1, properties: { '_exclusive-checkout-deals': 'true' } });
        fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
            return response.text();
        }).then((state) => {
          const parsedState = JSON.parse(state);
          _this.CARTUPDATE(parsedState);
          _btnLoading(el, false);
          var span = el.querySelector('span');
          if(span) span.innerHTML = "ADDED TO CART";
          setTimeout(function(){
            if(span) span.innerHTML = "ADD TO CART";
          },2000);
        }).catch((e) => {
          console.log("error",e);
          console.error(e);
        });
      });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'announcement-bar-cart-deal',
        section: 'announcement-bar-cart-deal',
        selector: '.ab-cart-header-information',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    GA4.added_or_removed(line-1, quantity);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if(elementToReplace){
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateQuantity_For_Gift($id,line) {
    this.enableLoading(line);
    var _this = this;
    var data = { updates: {} };
    data.updates[$id] = '0';
    data.attributes = { [$id]:"removed"};
    data.sections = this.getSectionsToRender().map((section) => section.section);
    data.sections_url = window.location.pathname;

    fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(response => {
        return response.text();
    }).then((state) => {
      const parsedState = JSON.parse(state);
      _this.CARTUPDATE(parsedState);
    });

    return;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  Checkproduct(cart){
    var _this = this;
      var items = cart.items;
      items.forEach(function(i,v){
        // Purple Dot required change
        // Don't remove the insurance product if on the /cart page, as this is where Purple Dot
        // will mount its checkout. Otherwise, the insurance product will always be removed for pre-orders.
        if(i.product_id == InsuranceData.product_id && !window.location.href.includes('/cart')){
        // if(i.product_id == InsuranceData.product_id){
          var variant_id = i.id;
          var data = { updates: {} };
          data.updates[variant_id] = '0';
          data.sections_url = window.location.pathname;
          data.sections = _this.getSectionsToRender().map((section) => section.section);
          fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            window.cart = parsedState;
            _this.CARTUPDATE(parsedState);
          });
        }
      });
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

var InsuranceData = {
  "product_id": 4383275614296,
  "basic_variant": 31676161654872,
  "threshold_price": 100.00,
  "basic_price": 2.09,
  "variants": [{"name":"Basic Shipping Protection","price":"2.09","id":31676161654872},{"name":"A$2.54","price":"2.54","id":31676161687640},{"name":"A$2.66","price":"2.66","id":43921391517830},{"name":"A$2.78","price":"2.78","id":43921391550598},{"name":"A$2.90","price":"2.90","id":43921391583366},{"name":"A$3.03","price":"3.03","id":43921391616134},{"name":"A$3.15","price":"3.15","id":43921391648902},{"name":"A$3.27","price":"3.27","id":43921391681670},{"name":"A$3.39","price":"3.39","id":43921391714438},{"name":"A$3.51","price":"3.51","id":43921391747206},{"name":"A$3.63","price":"3.63","id":43921391779974},{"name":"A$3.75","price":"3.75","id":43921391812742},{"name":"A$3.87","price":"3.87","id":43921391845510},{"name":"A$3.99","price":"3.99","id":43921391878278},{"name":"A$4.11","price":"4.11","id":43921391911046},{"name":"A$4.24","price":"4.24","id":43921391943814},{"name":"A$4.36","price":"4.36","id":43921391976582},{"name":"A$4.48","price":"4.48","id":43921392009350},{"name":"A$4.60","price":"4.60","id":43921409441926},{"name":"A$4.72","price":"4.72","id":43921392042118},{"name":"A$4.84","price":"4.84","id":43921392074886},{"name":"A$4.96","price":"4.96","id":43921392107654},{"name":"A$5.08","price":"5.08","id":43921392140422},{"name":"A$5.20","price":"5.20","id":43921392173190},{"name":"A$5.32","price":"5.32","id":43921392205958},{"name":"A$5.45","price":"5.45","id":43921392238726},{"name":"A$5.57","price":"5.57","id":43921392271494},{"name":"A$5.69","price":"5.69","id":43921392304262},{"name":"A$5.81","price":"5.81","id":43921392337030},{"name":"A$5.93","price":"5.93","id":43921392369798},{"name":"A$6.05","price":"6.05","id":43921392402566},{"name":"A$6.29","price":"6.29","id":43921392435334},{"name":"A$6.53","price":"6.53","id":43921392468102},{"name":"A$6.78","price":"6.78","id":43921392500870},{"name":"A$7.02","price":"7.02","id":43921392533638},{"name":"A$7.26","price":"7.26","id":43921392566406},{"name":"A$7.50","price":"7.50","id":43921392599174},{"name":"A$7.74","price":"7.74","id":43921392631942},{"name":"A$7.99","price":"7.99","id":43921392664710},{"name":"A$8.23","price":"8.23","id":43921392697478},{"name":"A$8.47","price":"8.47","id":43921392730246},{"name":"A$8.71","price":"8.71","id":43921392763014},{"name":"A$8.95","price":"8.95","id":43921392795782},{"name":"A$9.20","price":"9.20","id":43921392828550},{"name":"A$9.44","price":"9.44","id":43921392861318},{"name":"A$9.68","price":"9.68","id":43921392894086},{"name":"A$9.92","price":"9.92","id":43921392926854},{"name":"A$10.16","price":"10.16","id":43921392959622},{"name":"A$10.41","price":"10.41","id":43921392992390},{"name":"A$10.65","price":"10.65","id":43921393025158},{"name":"A$10.89","price":"10.89","id":43921393057926},{"name":"A$11.13","price":"11.13","id":43921393090694},{"name":"A$11.37","price":"11.37","id":43921393123462},{"name":"A$11.62","price":"11.62","id":43921393156230},{"name":"A$11.86","price":"11.86","id":43921393188998},{"name":"A$12.10","price":"12.10","id":43921393221766},{"name":"A$12.34","price":"12.34","id":43921393254534},{"name":"A$12.58","price":"12.58","id":43921393287302},{"name":"A$12.83","price":"12.83","id":43921393320070},{"name":"A$13.07","price":"13.07","id":43921393352838},{"name":"A$13.31","price":"13.31","id":43921393385606},{"name":"A$13.79","price":"13.79","id":43921393418374},{"name":"A$14.28","price":"14.28","id":43921393451142},{"name":"A$14.76","price":"14.76","id":43921393483910},{"name":"A$15.25","price":"15.25","id":43921393516678},{"name":"A$15.73","price":"15.73","id":43921393549446},{"name":"A$16.21","price":"16.21","id":43921393582214},{"name":"A$16.70","price":"16.70","id":43921393614982},{"name":"A$17.18","price":"17.18","id":43921393647750},{"name":"A$17.67","price":"17.67","id":43921393680518},{"name":"A$18.15","price":"18.15","id":43921393713286},{"name":"A$18.63","price":"18.63","id":43921393746054},{"name":"A$19.12","price":"19.12","id":43921393778822},{"name":"A$19.60","price":"19.60","id":43921409474694},{"name":"A$20.09","price":"20.09","id":43921393811590},{"name":"A$20.57","price":"20.57","id":43921393844358},{"name":"A$21.05","price":"21.05","id":43921393877126},{"name":"A$21.54","price":"21.54","id":43921393909894},{"name":"A$22.02","price":"22.02","id":43921393942662},{"name":"A$22.51","price":"22.51","id":43921393975430},{"name":"A$22.99","price":"22.99","id":43921394008198},{"name":"A$24.20","price":"24.20","id":43921394040966},{"name":"A$25.41","price":"25.41","id":43921394073734},{"name":"A$26.62","price":"26.62","id":43921394106502},{"name":"A$27.83","price":"27.83","id":43921394139270},{"name":"A$29.04","price":"29.04","id":43921394172038},{"name":"A$30.25","price":"30.25","id":43921394204806},{"name":"A$31.46","price":"31.46","id":43921394237574},{"name":"A$32.67","price":"32.67","id":43921394270342},{"name":"A$33.88","price":"33.88","id":43921394303110},{"name":"A$35.09","price":"35.09","id":43921394335878},{"name":"A$36.30","price":"36.30","id":43921394368646},{"name":"A$37.51","price":"37.51","id":43921394401414},{"name":"A$38.72","price":"38.72","id":43921394434182},{"name":"A$39.93","price":"39.93","id":43921394466950},{"name":"A$41.14","price":"41.14","id":43921394499718},{"name":"A$42.35","price":"42.35","id":43921394532486},{"name":"A$43.56","price":"43.56","id":43921394565254},{"name":"A$44.77","price":"44.77","id":43921394598022},{"name":"A$45.98","price":"45.98","id":43921394630790},{"name":"A$47.19","price":"47.19","id":43921394663558},{"name":"A$48.40","price":"48.40","id":43921394696326},{"name":"A$50.82","price":"50.82","id":43921394729094},{"name":"A$53.24","price":"53.24","id":43921394761862},{"name":"A$55.66","price":"55.66","id":43921394794630},{"name":"A$58.08","price":"58.08","id":43921394827398},{"name":"A$60.50","price":"60.50","id":43921394860166},{"name":"A$62.92","price":"62.92","id":43921394892934},{"name":"A$65.34","price":"65.34","id":43921394925702},{"name":"A$67.76","price":"67.76","id":43921394958470},{"name":"A$70.18","price":"70.18","id":43921394991238},{"name":"A$72.60","price":"72.60","id":43921395024006},{"name":"A$75.02","price":"75.02","id":43921395056774},{"name":"A$77.44","price":"77.44","id":43921395089542},{"name":"A$79.86","price":"79.86","id":43921395122310},{"name":"A$82.28","price":"82.28","id":43921395155078},{"name":"A$84.70","price":"84.70","id":43921395187846},{"name":"A$87.12","price":"87.12","id":43921395220614},{"name":"A$89.54","price":"89.54","id":43921395253382},{"name":"A$91.96","price":"91.96","id":43921395286150},{"name":"A$94.38","price":"94.38","id":43921395318918},{"name":"A$96.80","price":"96.80","id":43921395351686},{"name":"A$99.22","price":"99.22","id":43921395384454},{"name":"A$101.64","price":"101.64","id":43921395417222},{"name":"A$104.06","price":"104.06","id":43921395449990},{"name":"A$106.48","price":"106.48","id":43921395482758},{"name":"A$108.90","price":"108.90","id":43921395515526},{"name":"A$111.32","price":"111.32","id":43921395548294},{"name":"A$113.74","price":"113.74","id":43921395581062},{"name":"A$116.16","price":"116.16","id":43921395613830},{"name":"A$118.58","price":"118.58","id":43921395646598},{"name":"A$121.00","price":"121.00","id":43921395679366},{"name":"A$125.84","price":"125.84","id":43921395712134},{"name":"A$130.68","price":"130.68","id":43921395744902},{"name":"A$135.52","price":"135.52","id":43921395777670},{"name":"A$140.36","price":"140.36","id":43921395810438},{"name":"A$145.20","price":"145.20","id":43921395843206},{"name":"A$150.04","price":"150.04","id":43921395875974},{"name":"A$154.88","price":"154.88","id":43921395908742},{"name":"A$159.72","price":"159.72","id":43921395941510},{"name":"A$164.56","price":"164.56","id":43921395974278},{"name":"A$169.40","price":"169.40","id":43921396007046},{"name":"A$174.24","price":"174.24","id":43921396039814},{"name":"A$179.08","price":"179.08","id":43921396072582},{"name":"A$183.92","price":"183.92","id":43921396105350},{"name":"A$188.76","price":"188.76","id":43921396138118},{"name":"A$193.60","price":"193.60","id":43921396170886},{"name":"A$198.44","price":"198.44","id":43921396203654},{"name":"A$203.28","price":"203.28","id":43921396236422},{"name":"A$208.12","price":"208.12","id":43921396269190},{"name":"A$212.96","price":"212.96","id":43921396301958},{"name":"A$217.80","price":"217.80","id":43921396334726},{"name":"A$222.64","price":"222.64","id":43921396367494},{"name":"A$227.48","price":"227.48","id":43921396400262},{"name":"A$232.32","price":"232.32","id":43921396465798},{"name":"A$237.16","price":"237.16","id":43921396498566},{"name":"A$242.00","price":"242.00","id":43921396531334},{"name":"A$246.84","price":"246.84","id":43921396564102},{"name":"A$251.68","price":"251.68","id":43921396596870},{"name":"A$256.52","price":"256.52","id":43921396629638},{"name":"A$261.36","price":"261.36","id":43921396662406}]
}

var EliteProtection = {
  Init: function(){
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      EliteProtection.InitWithCart(cart);
    });
  },
  InitWithCart: function(cart){
    var cart_total = 0,
        InsuranceValue = 0,
        Protectionstatus = EliteProtection.getCookie('Protectionstatus');
    for(t=0; t < cart.items.length; t++){
      if(cart.items[t].handle != 'gift-card'){
        cart_total = cart_total+cart.items[t].final_line_price;
      }
    }
    cart_total = cart_total/100;
    var insurancePriceEl = document.getElementById('insurancePrice');
    if(cart_total > InsuranceData.threshold_price){
      var value = EliteProtection.getClosests(cart_total,InsuranceData.variants);
      if(insurancePriceEl) insurancePriceEl.innerHTML = Shopify.formatMoney(value.price*100,Shopify.money_format);
      if(Protectionstatus == "true"){
        InsuranceValue = value.price;
      }
    }else{
      if(insurancePriceEl) insurancePriceEl.innerHTML = Shopify.formatMoney(InsuranceData.basic_price*100,Shopify.money_format);
      if(Protectionstatus == "true"){
        InsuranceValue = InsuranceData.basic_price;
      }
    }

    var CartTotal_with_insurance = parseFloat(cart.total_price);
    var easyProtection = document.getElementById('easy-protection');
    if(Protectionstatus == "true"){
      if(easyProtection) easyProtection.checked = true;
      CartTotal_with_insurance = CartTotal_with_insurance + parseFloat(InsuranceValue*100);
    }else{
      if(easyProtection) easyProtection.checked = false;
    }
    var onlygift = true;
    for(i=0; i < cart.items.length;i++){
      var Item = cart.items[i];
      if(Item.handle != 'gift-card'){
        if(Item.properties && Item.properties['_free-product']){
        }else{
          onlygift = false;
        }
      }
    }

    if(onlygift){
      cart_total = (Math.abs(parseFloat(cart_total)))*100;
    }else{
      cart_total = (Math.abs(parseFloat(cart_total)+parseFloat(InsuranceValue)))*100;
    }
    document.querySelectorAll('.totals__total-value').forEach(function(el){ el.innerHTML = Shopify.formatMoney(CartTotal_with_insurance,Shopify.money_format)+" AUD"; });

    const earningPrice = cart.total_price * 0.05;
    document.querySelectorAll('.earning-text span').forEach(function(el){ el.innerHTML = Shopify.formatMoney(earningPrice,Shopify.money_format); });
  },
  AddToCard: function(variant){
    let formData = { 'items': [{ 'id': variant,'quantity': 1 }] };
    fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
      // window.location.href = '/checkout';
      // Purple dot change
      navigateToCheckout();
    }).catch((error) => {
      // window.location.href = '/checkout';
      // Purple dot change
      navigateToCheckout();
    });
  },
  getClosests: function getClosests(total, variants) {
    var counts = variants,
        goal = total*2.42/100;
    var closest = counts.reduce(function(prev, curr) {
      return Math.abs(parseFloat(curr.price) - parseFloat(goal)) < Math.abs(parseFloat(prev.price) - goal) ? curr : prev;
    });
    return closest;
  },
  CookieInit: function(){
    var Protectionstatus = EliteProtection.getCookie('Protectionstatus');
    if(Protectionstatus == null){
      document.cookie = "Protectionstatus=true";
    }
  },
  getCookie: function(name){
    var cookieArr = document.cookie.split(";");
    for(var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      if(name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }
}

document.addEventListener('change', function(e){
  var el = e.target.closest('#easy-protection');
  if(!el) return;
  if(el.checked === true){
    document.cookie = "Protectionstatus=true";
  } else{
    document.cookie = "Protectionstatus=false";
  }
  EliteProtection.Init();
});

window.onload = function () {
  EliteProtection.CookieInit();
}

document.addEventListener('click', function(e){
  var el = e.target.closest('#CartDrawer-Checkout, #checkout');
  if(!el) return;
  e.stopPropagation();
  e.preventDefault();
  el.innerHTML = "Loading Checkout <span class='dot-typing'></span>";
  var EasyStatus = EliteProtection.getCookie('Protectionstatus');
    if(EasyStatus && EasyStatus == "true"){
      window.cart_have_pre_order = false;
      fetch('/cart.js').then(res => res.json()).then((cart) => {
        var cart_total = 0,
            InsuranceValue = 0,
            onlygift = true;

        for(t=0; t < cart.items.length; t++){
          var Item = cart.items[t];
          if(Item.handle != 'gift-card'){
            cart_total = cart_total+cart.items[t].final_line_price;
          }
          if(Item.properties && Item.properties['_is_preorder'] == "yes"){
            window.cart_have_pre_order = true;
          }
        }
        cart_total = cart_total/100;

        for(i=0; i < cart.items.length;i++){
          var Item = cart.items[i];
          if(Item.handle != 'gift-card'){
            if(Item.properties && Item.properties['_free-product']){
            }else{
              onlygift = false;
            }
          }
        }

        if(cart_total > InsuranceData.threshold_price){
          var InsuranceVariant = EliteProtection.getClosests(cart_total,InsuranceData.variants);
          InsuranceVariant = InsuranceVariant.id;
        }else{
          InsuranceVariant = InsuranceData.basic_variant;
        }
        if(onlygift){
          navigateToCheckout();
        }else{
          EliteProtection.AddToCard(InsuranceVariant);
        }

      });
    }else{
      navigateToCheckout();
    }
  setTimeout(function(){
    navigateToCheckout();
  },7000);
});

async function navigateToCheckout() {
  if (window.cart_have_pre_order == true && window.pre_order_status == true) {
    fetch("/cart?view=token", { credentials: "same-origin", method: "GET" }).then((function(data) {
      data.text().then((function(data) {
          data = JSON.parse(data);
          var payload = data.token_object;
          payload.hmac = data.token_key;
          var cart_token = btoa(JSON.stringify(payload));
          var $newurl = "https://checkout.elitesupps.com.au/cart?token="+cart_token;
          window.location.href = $newurl;
      }));
    }));
  } else {
    window.location.href = '/checkout';
  }
}
